meedy.factory('meedy.mdxOrderService', ['$http', '$q', '$translate', 'fileHelper', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($http, $q, $translate, fileHelper, baseService, objectHelper, config) {

        function MdxOrderService() {

            this.getOrderDetails = function(id) {
                return baseService.get(config.MDX_API_URL + '/order/getOrderDetails?idOrder=' + id).then(
                    function(successResponse) {
						
                        return objectHelper.translateObject(successResponse.order, MdxOrderVO);
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getOrderFiles = function(criteria) {
                return baseService.post(config.MDX_API_URL + '/file/order/getDataPage', criteria).then(
                    function(successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, MdxFileVO);

                        return dataPage;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getDownloadToken = function (orderId, fileId) {
                return doGetDownloadToken(orderId, [fileId], Enum.MDX_FILE_TYPE.ORDER_FILES);
            };

            this.getDownloadMergedFilesToken = function (orderId, fileIds, downloadType) {
                return doGetDownloadToken(orderId, fileIds, downloadType);
            };


            this.uploadFile = function (formData) {

                var req = {
                    method: 'POST',
                    url: config.MDX_FILE_DOWNLOAD_PREFIX + '/upload',
                    headers: {'Content-Type': undefined},
                    data: formData
                };
                return $http(req).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                    	// todo - change to foreward error if Icrmed sets correct CORS on the server
                        return errorResponse;
                    }
                );

            };

            this.getUploadToken = function (id, filesize, md5hash) {
                return baseService.get(config.MDX_API_URL + '/file/order/getUploadToken?selectedFileSize=' + filesize + '&uploadType=ORDER_FILES&idEvent=' + id + '&md5hash=' + md5hash).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };
	
			this.sendFileAttachedEmail = function (mdxSendFileAttachedEmail) {
				return baseService.post(config.MDX_API_URL + '/file/order/sendFileAttachedEmail', mdxSendFileAttachedEmail).then(
					function(successResponse) {
						return successResponse;
					},
					function(errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
			
            this.deleteFile = function (id) {
                return baseService.delete(config.MDX_API_URL + '/file/order/' + id).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            function doGetDownloadToken(orderId, fileIds, downloadType) {
                return baseService.post(config.MDX_API_URL + '/file/order/authorizeFileDownload', {
                    downloadType: downloadType,
                    idsFiles: fileIds,
                    idEvent: orderId
                }).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            }

        }

        return new MdxOrderService();
    }
]);
